<template>
  <HeaderBar />

  <ButtonBackContainer>
    <ButtonBack :fallback="{ name: 'userList' }">{{ t('backToUsers') }}</ButtonBack>
  </ButtonBackContainer>

  <section class="carvia-container">
    <div class="mb-6 flex justify-end">
      <CVButton :to="{ name: 'partnerSubType', params: { id: 'new' } }">
        {{ t('createPartnerSubType') }}
      </CVButton>
    </div>

    <div v-if="partnerSubTypes.length" class="flex flex-col space-y-2">
      <div v-for="partnerSubType in partnerSubTypes" :key="partnerSubType.id">
        <PartnerSubTypeListItem :partner-sub-type="partnerSubType" />
      </div>
    </div>

    <EntityListExceptions
      :status="status"
      :error="error"
      :items-count="partnerSubTypes.length"
      :no-items-text="t('noPartnerSubTypesFound')"
    />
  </section>
</template>

<script lang="ts" setup>
import ButtonBack from '@/components/buttons/ButtonBack.vue';
import ButtonBackContainer from '@/components/ButtonBackContainer.vue';
import CVButton from '@/components/buttons/CVButton.vue';
import EntityListExceptions from '@/components/EntityListExceptions.vue';
import HeaderBar from '@/components/headerbar/HeaderBar.vue';
import { usePartnerSubTypes } from '@/queries/use-users';
import { useUiStore } from '@/stores/ui.store';
import { computed, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import PartnerSubTypeListItem from './PartnerSubTypeListItem.vue';

const { t } = useI18n();
const uiStore = useUiStore();

const { data, status, error } = usePartnerSubTypes();

const partnerSubTypes = computed(() => data.value ?? []);

watchEffect(() => {
  uiStore.setHeaderTitle(t('partnerSubTypes'));
});
</script>

<i18n lang="json">
{
  "en": {
    "backToUsers": "Back to Users",
    "partnerSubTypes": "Partner Sub Types",
    "createPartnerSubType": "+ Create Partner Sub Type",
    "noPartnerSubTypesFound": "No partner sub types found"
  },
  "de": {
    "backToUsers": "Zurück zu Benutzern",
    "partnerSubTypes": "Partner-Subtypen",
    "createPartnerSubType": "+ Partner-Subtyp erstellen",
    "noPartnerSubTypesFound": "Keine Partner-Subtypen gefunden"
  }
}
</i18n>
